import React, { useState } from 'react'
import PropTypes from 'prop-types'
import AsyncSelect from 'react-select/async'
import Educator from '../../../../models/Educator'

const loadTeacherOptions = ({ valueField, schoolId, season }) => (value, callback) => {
  Educator
    .where({ with_enrolled_students_for_school_id: schoolId })
    .where(season ? { season } : {})
    .where({
      name: { match: value },
    })
    .order({ name: 'asc' })
    .all()
    .then((res) => {
      const options = res.data
        .filter(e => e.name.toUpperCase() !== 'STAFF')
        .map((e) => ({ label: e.name, value: e[valueField]}))
      callback([{ label: 'Staff', value: 'staff' }, ...options])
    })
}

const AsyncTeacherSelect = ({ name, selectedValue, valueField, placeholder, schoolId, season }) => {
  const [option, setOption] = useState(selectedValue)

  const teacherOptions = loadTeacherOptions({ valueField, schoolId: schoolId, season })

  const changeHandler = (opt) => {
    let url = `/schools/${schoolId}/class_pictures?teacher_id=${opt.value}`
    if (season) url += `&season=${encodeURIComponent(season)}`
    window.location = url
  }

  return (
    <>
      <AsyncSelect
        cacheOptions
        defaultOptions
        placeholder={placeholder}
        defaultValue={selectedValue}
        name={name}
        loadOptions={teacherOptions}
        onChange={changeHandler}
      />
    </>
  )
}

AsyncTeacherSelect.propTypes = {
  name: PropTypes.string,
  selectedValue: PropTypes.object,
  valueField: PropTypes.string,
  extraFields: PropTypes.array,
  placeholder: PropTypes.string,
  season: PropTypes.string,
}

AsyncTeacherSelect.defaultProps = {
  name: null,
  selectedValue: null,
  valueField: 'name',
  extraFields: [],
  placeholder: 'Search All',
  season: null,
}

export default AsyncTeacherSelect
